import { LeftSidebarOptions } from '../../../../../../features/editor-left-sidebar';
import { IconMap } from '../../../../../../shared/sprite';

export const sidebarOptions = [
  {
    id: LeftSidebarOptions.ELEMENTS,
    icon: IconMap.Grid02,
    name: 'Elements',
  },
  {
    id: LeftSidebarOptions.VIDEOS,
    icon: IconMap.Film02,
    name: 'Videos',
  },
  {
    id: LeftSidebarOptions.CALLS,
    icon: IconMap.HeadPhones02,
    name: 'Calls',
  },
  {
    id: LeftSidebarOptions.SETTINGS,
    icon: IconMap.Settings04,
    name: 'Settings',
  },
];
